import axios from "axios";

//export const apiURL = "http://192.168.29.127:8080/"
// export const apiURL = "http://192.168.1.13:8080/"
export const frontendURL =
  process.env.REACT_APP_FRONTEND_URL;

export const apiURL =
  process.env.REACT_APP_API_URL;

export const socketURL =
  process.env.REACT_APP_SOCKET_URL;

export const baseURL = apiURL;

export const docUrl =
  process.env.REACT_APP_DOC_URL;

export const googleMapApiKey =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

axios.defaults.baseURL = baseURL;

// Global 401 handler: force user to login again
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      // Clear any known auth payloads used across the app
      localStorage.removeItem("dna_admin");
      localStorage.removeItem("vn_associates_insurance_admin");

      // Avoid redirect loops if already on login
      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
